import { useEffect } from 'react';
import { populateItemID } from '../utils';

// NOTE: used when embedding child editors. This relies on the parent save to
// commit changes.
export default function useChildEditor({
  init = {
    status: 'draft',
    label: 'general',
  },
  validation,
  onChange,
  onEditorSetup,
}) {
  useEffect(() => onEditorSetup(validation), []);

  const item = { ...init, children: (init.children || []).map(populateItemID) };

  const onFieldChange = key => e => {
    onChange({
      ...item,
      [key]: e.target.value,
    });
  };

  const onAddOption = option => {
    const children = [...(item.children || []), { ...option, type: 'option' }];
    onChange({
      ...item,
      children,
    });
  };

  const onChangeOption = option => {
    const children = item.children.map(oldOption => {
      if (oldOption.id === option.id) {
        return option;
      }

      return oldOption;
    });
    onChange({
      ...item,
      children,
    });
  };

  const onRemoveOption = option => {
    onChange({
      ...item,
      children: item.children.filter(o => o.id !== option.id),
    });
  };

  return {
    item,
    onFieldChange,
    onAddOption,
    onChangeOption,
    onRemoveOption,
  };
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/hooks/use-child-editor.jsx